<template>
	<div v-if="displayDataEdit">
		<!-- Dimensions -->
		<b-container class="dimensions-container">
			<b-row> 
				<b-col class="group-title">
					<h3> Dimensions </h3>
				</b-col>
			</b-row>
			<b-row> 
				<b-col cols="8" />
				<b-col v-if="!editMode" cols="2" />
				<b-col
					v-if="!editMode"
					cols="1"
					class="date-icon"
				>
					<b-icon 
						v-b-tooltip.hover.top="formatDate(displayDataEdit.asOfDate)"
						icon="clock"
						style="float: right;" 
					/>
				</b-col>
				<b-col
					v-if="editMode"
					cols="3"
					style="padding: 0px;"
				>
					<b-form-datepicker
						id="datepicker"
						v-model="displayDataEdit.asOfDate"
						size="sm" 
						locale="en" 
						placeholder="Choose a date"
						:date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
					/>
				</b-col>
				<b-col cols="1" class="edit-button">
					<b-button variant="link" @click="edit()">
						Edit
					</b-button>
				</b-col>
			</b-row>
			
			<b-row> 
				<b-col>
					<h5> Above-Grade </h5>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<field-input
						v-model="displayDataEdit.aboveGradeHeight"
						:mode="editMode"
						:step="0.01"
						label="Height"
						unit="ft."
					/>
				</b-col>
				<b-col>
					<field-input
						v-model="displayDataEdit.aboveGradeFloors"
						:mode="editMode"
						label="Floors"
					/>
				</b-col>
			</b-row>
			<b-row> <div style="height: 12px;" /> </b-row>
			<b-row> 
				<b-col>
					<h5> Below-Grade </h5>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<field-input
						v-model="displayDataEdit.belowGradeDepth"
						:mode="editMode"
						:step="0.01"
						label="Depth"
						unit="ft."
					/>
				</b-col>
				<b-col>
					<field-input
						v-model="displayDataEdit.belowGradeFloors"
						:mode="editMode"
						label="Floors"
					/>
				</b-col>
			</b-row>
			<b-row> <div style="height: 12px;" /> </b-row>
			<b-row> 
				<b-col>
					<h5> Area </h5>
				</b-col>
			</b-row>
			<b-row> 
				<b-col>
					<field-input
						v-model="displayDataEdit.floorArea"
						:mode="editMode"
						:step="0.01"
						label="Floor Area"
						unit="ft.^2"
					/>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<field-input
						v-model="displayDataEdit.parcelArea"
						:mode="editMode"
						:step="0.01"
						label="Parcel Area"
						unit="ft.^2"
					/>
				</b-col>
				<b-col>
					<field-input
						v-model="displayDataEdit.floorToAreaRatio"
						:mode="editMode"
						:step="0.01"
						label="Floor Area Ratio (FAR)"
					/>
				</b-col>
			</b-row>
			<b-row> 
				<b-col>
					<field-input
						v-model="displayDataEdit.footprintArea"
						:mode="editMode"
						:step="0.01"
						label="Footprint Area"
						unit="ft.^2"
					/>
				</b-col>
			</b-row>
			<b-row> <div style="height: 12px;" /> </b-row>
			<b-row> 
				<b-col>
					<h5> Efficiency </h5>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<field-input
						v-model="displayDataEdit.rentableArea"
						:mode="editMode"
						:step="0.01"
						label="Rentable Area"
						unit="ft.^2"
					/>
				</b-col>
				<b-col>
					<field-input
						v-model="displayDataEdit.usableArea"
						:mode="editMode"
						:step="0.01"
						label="Usable Area"
						unit="ft.^2"
					/>
				</b-col>
			</b-row>
			<b-row> 
				<b-col>
					<field-input
						v-model="displayDataEdit.rentableUsableFactor"
						:mode="editMode"
						:step="0.01"
						label="R/U Factor"
					/>
				</b-col>
			</b-row>
			<b-row> <div style="height: 12px;" /> </b-row>
		</b-container>

		<!-- Composition -->

		<b-container class="composition-container">
			<b-row> 
				<b-col class="group-title">
					<h3> Composition </h3>
				</b-col>
			</b-row>
			<b-row> 
				<b-col>
					<field-input
						v-model="displayDataEdit.unitCount"
						:mode="editMode"
						label="Asset Unit Count"
					/>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<field-input
						v-model="displayDataEdit.unitFloorArea"
						:mode="editMode"
						:step="0.01"
						label="Asset Unit Floor Area"
						unit="ft.^2"
					/>
				</b-col>
				<b-col>
					<field-input
						v-model="displayDataEdit.pctOfAssetFloorArea"
						:mode="editMode"
						:step="0.01"
						label="% of Asset Floor Area"
						unit="%"
					/>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import FieldInput from './FieldInput.vue';

export default {
	name: 'AssetDesign',
	components: {FieldInput},
	filters: {},
	props: {

	},
	data() {
		return {
			editMode: false,
			displayDataEdit: {}
		};
	},
	computed: {
		...mapState(['elementEditorEntityDataId']),
		formatDate() {
			return date => (!date || date === '') ? `Not updated`: new Intl.DateTimeFormat('en-US', { dateStyle: 'long' }).format(new Date(date.replace(/-/g, '/').replace(/T.+/, '')))
		}
	},
	watch: {
		elementEditorEntityDataId: {
			immediate: true,
			deep: true,
			handler() {
				this.getData();
			},
		},
		displayDataEdit: {
			deep: true,
			handler() {
				this.updateData();
			},
		},
		data: {
			immediate: true,
			handler(newVal) {
				this.displayDataEdit = newVal;
			},
		}
	},
	created() {
		
	},
	mounted() {
	},
	methods: {
		edit() {
			this.editMode = !this.editMode;
		},
		async getData() {
			const assetdesignData = await this.axios.get(
				`/entities/${this.elementEditorEntityDataId}/assetdesigns`
			);
			this.displayDataEdit = assetdesignData.data;
		},
		async updateData() {
			if (this.displayDataEdit && this.displayDataEdit.id) {
				const postAssetDesignModelData = await this.axios.patch(
					`/assetdesigns/${this.displayDataEdit.id}`,
					this.displayDataEdit
				);
			}
		}
	},
};
</script>

<style scoped>
.group-title {
	text-align: center;
}
.date-icon {
	margin-top: auto;
	margin-bottom: auto;
	padding-right: 5px;
}
.date-text {
	margin-top: auto;
	margin-bottom: auto;
	padding: 0px;
}
.edit-button {
	margin-top: auto;
	margin-bottom: auto;
	padding: 0px 0px 0px 3px;
}
</style>
